// action
import {
    DELETE_ADMIN_TYPE,
    DELETE_ADMIN_TYPE_FAIL,
    DELETE_ADMIN_TYPE_SUCCESS,
    DELETE_ADMIN_TYPE_RESET
} from '../action/deleteAdminTypeAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_ADMIN_TYPE:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_ADMIN_TYPE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_ADMIN_TYPE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_ADMIN_TYPE_RESET:
            return initialState
        default:
            return state
    }
}